<a
  *ngIf="document?.link && document?.downloadUrl; else emDash"
  target="_blank"
  [href]="document.link"
  data-analytics-no-event="true"
  [attr.aria-label]="'common.fund-document' | translate"
  (click)="triggerAnalyticsEvent()"
>
  <eds-icon type="pdf" size="large"></eds-icon>
</a>
<ng-template #emDash>
  <div edsPadding edsPaddingLeft="xs">—</div>
</ng-template>
